import React from "react";
import Breadcrumbs from "../ui/nav/Breadcrumbs/Breadcrumbs";

import ReactCountryFlag from "react-country-flag";

import BasicWeatherWidget from "components/widgets/weather/BasicWeatherWidget/BasicWeatherWidget";

import styles from "./Intro.module.scss";

const Intro = ({
  destination,
  countryDetail,
  destinationWeather,
  weatherLoading,
}) => {
  const regionName = destination?.destination_details?.region?.regionName;
  const regionSlug = destination?.destination_details?.region?.region;
  const destinationTitle = destination?.destination_title;
  const destinationTitleUpper = destinationTitle?.toUpperCase();
  const countryShortCode = destination?.destination_details?.country_short_code;

  return (
    <div className={`variable-container`}>
      <div className={`${styles.container}`}>
        <div className={`${styles.countryInfo}`}>
          {/* <div className={`${styles.breadCrumbs}`}> */}
          <Breadcrumbs
            breadcrumbs={[
              { name: regionName, link: `/destinations/${regionSlug}` },
              {
                name: destination?.destination_title,
                link: `/destinations/${regionSlug}/${destination?.slug}`,
              },
            ]}
          />
          {/* </div> */}
          <div className={`${styles.pageTitle}`}>
            <span className={`${styles.flagWrapper}`}>
              <ReactCountryFlag
                countryCode={countryShortCode}
                svg
                alt={`${destinationTitle} flag`}
                style={{
                  width: "33px",
                  height: "24px",
                  border: "1px solid black",
                  background: "black",
                }}
                title={destinationTitle}
              />
            </span>

            <h1 className={`${styles.mainTagLine}`}>
              {destinationTitle} Travel Information
            </h1>
          </div>
        </div>
        <span className={`${styles.weather}`}>
          <BasicWeatherWidget
            destination={destination}
            countryDetail={countryDetail}
            destinationWeather={destinationWeather}
            loading={weatherLoading}
          />
        </span>
      </div>
    </div>
  );
};

export default Intro;
